<template>
  <div class="d-flex flex-column ga-2 align-center justify-center">
    <v-icon size="40" :icon="InfoIcon" color="#FFCE31" class="mt-6"/>
    <div class="title">{{$t('Удалить язык?')}}</div>
    <div class="sub-title">{{$t('Если вы удалите этот язык, вкладка исчезнет. Страница на других языках останется без изменений. Вы сможете добавить язык снова в настройках')}}}</div>
    <v-btn variant="outlined" color="accent" rounded="lg" class="w-100 mt-2 remove-btn" @click="reset">
      {{$t('Удалить')}}
    </v-btn>
  </div>

</template>

<script setup lang="ts">
import InfoIcon from "~/assets/icons/info.vue";
import {useTapStore} from "@/stores/tapStore";
import {useDialogStore} from "@/stores/dialogStore";

const tapStore = useTapStore();
const dialogStore = useDialogStore();

const reset = () => {
  tapStore.resetLang(tapStore.currentTapLang?.lang)
  dialogStore.close()
}
</script>

<style scoped lang="sass">
.title
  color: #000
  text-align: center
  font-size: 20px
  font-weight: 600
  line-height: normal
.sub-title
  color: #363636
  text-align: center
  font-size: 14px
  font-weight: 400
  line-height: normal
  max-width: 272px
.remove-btn
  ::v-deep.v-btn__content
    color: #B20320
</style>
